import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'src/app/Models/User';
import { UserService } from 'src/app/Services/User/user.service';
import { Commentaire } from 'src/app/Models/Commentaire';
import { CommentaireService } from 'src/app/Services/Commentaire/commentaire.service';
import { faFlag, faMapMarker, faUniversity, faCalendar, faInfoCircle, faBrain, faObjectGroup, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faHeart, faTrash, faComment, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { Event } from 'src/app/Models/Event';
import { EventService } from 'src/app/Services/Event/event.service';

@Component({
  selector: 'app-profile-club',
  templateUrl: './profile-club.component.html',
  styleUrls: ['./profile-club.component.scss']
})
export class ProfileClubComponent implements OnInit {
  activeSection: string = 'clubevents';
  ratingActivated: boolean = false;
  eventsActivated: boolean = false;
  

  date = new Date().getUTCFullYear();
  id: any = null;
  userId : any ; 
  user: User = null;
  faFlag = faFlag;
  faMapMarker = faMapMarker;
  faUniversity = faUniversity;
  faCalendar = faCalendar;
  faInfoCircle = faInfoCircle;
  faBrain = faBrain;
  faObjectGroup = faObjectGroup;
  faEnvelope = faEnvelope;
  commentaire: any;
  comment: any = {};
  faHeart = faHeart;
  faTrash = faTrash;
  faThumbsUp = faThumbsUp;
  faComment = faComment;
  faThumbsDown = faThumbsDown;
  listReponse: any;
  ListEvent: any;
  hideCommentform = true;
  ListAlumni:any ;

  constructor(private router: Router,
    private activateRoute: ActivatedRoute,
     private userService: UserService,
     private commentaireservice:CommentaireService,
     private eventservice:EventService) { }

  ngOnInit(): void {
    this.findUserById();
    this.getCommentaireByEventId();
    this.getAllEventsbyIdUser();
   
    /*this.id = localStorage.getItem("Id");
    this.userId = localStorage.getItem("IdUser");
    console.log(this.id);
    console.log(this.userId);*/
  }

  findUserById(){
    this.id = localStorage.getItem("IdUser");
    this.userService.findById(this.id).subscribe(data=>{
      this.user = data ;
      return this.user;
    })
  }

  setEventId(id: any) {
    localStorage.setItem("IdEvent", id);
    console.log(this.id);
  }
  getCommentaireByEventId() {
    this.userId = localStorage.getItem("IdUser")
    this.id = localStorage.getItem("Id");
    this.commentaireservice.getCommentaireBytargetUserId(this.userId).subscribe(
      data => {
        this.commentaire = data;
        return this.commentaire;
      }
    );
  }

  addComment(comment: Commentaire) {
    this.id = localStorage.getItem("Id");
    this.userId = localStorage.getItem("IdUser");
    
    this.commentaireservice.addCommentaireUser(this.userId,this.id,comment).subscribe(
      data => {
        comment = data;
        console.log(comment)
        this.activateSection('rating');
        return comment;
      }
    );
  }

  deleteCommentaire(id: any) {
    this.commentaireservice.deleteCommentaire(id).subscribe(
      data => {
        return data;
      }
    );
  }

  hideSupp(id: any) {
    if (id == localStorage.getItem("Id")) {
      return false
    } else {
      return true
    }
  }

  activateSection(section: string) {
    this.activeSection = section;
  }


  getalumnibyclubid() {
    this.id = localStorage.getItem('IdUser');
    this.userService.getAlumnibyClub(this.id).subscribe((data) => {
      
      this.ListAlumni = data;
      console.log(this.ListAlumni);
      return this.ListAlumni;
    });
  }
  getAllEventsbyIdUser(){
    this.userId = localStorage.getItem("IdUser")
    this.eventservice.getEventsByid(this.userId).subscribe(
      data=>{
        this.ListEvent = data ;

        console.log(this.ListEvent);
      },
      error => {
        // Handle the error appropriately
        console.error('Failed to fetch events:', error);
      }
    );
    
  }
  
  


}